import { StepMap } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { SystemPermissionsMeetingPermissionsStep } from "./meeting-permissions-step";
import { SystemPermissionsMeetingIntroStep } from "./meeting-intro-step";

export const SystemPermissionsMeetingsStepsMap: StepMap = {
  "system-permissions-meeting-intro": {
    id: "system-permissions-meeting-intro",
    group: "system-permissions-meetings",
    render: props => <SystemPermissionsMeetingIntroStep {...props} />,
    fullHeight: true,
  },
  "system-permissions-meeting-permissions": {
    id: "system-permissions-meeting-permissions",
    group: "system-permissions-meetings",
    render: props => <SystemPermissionsMeetingPermissionsStep {...props} />,
    fullHeight: true,
  },
} as const;
